"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReCaptchaInstance_1 = require("./ReCaptchaInstance");
var ReCaptchaLoader = (function () {
    function ReCaptchaLoader() {
    }
    ReCaptchaLoader.load = function (siteKey, options) {
        if (options === void 0) { options = {}; }
        if (typeof document === 'undefined')
            return Promise.reject(new Error('This is a library for the browser!'));
        if (ReCaptchaLoader.getLoadingState() === ELoadingState.LOADED)
            if (ReCaptchaLoader.instance.getSiteKey() === siteKey)
                return Promise.resolve(ReCaptchaLoader.instance);
            else
                return Promise.reject(new Error('reCAPTCHA already loaded with different site key!'));
        if (ReCaptchaLoader.getLoadingState() === ELoadingState.LOADING) {
            if (siteKey !== ReCaptchaLoader.instanceSiteKey)
                return Promise.reject('reCAPTCHA already loaded with different site key!');
            return new Promise(function (resolve, reject) {
                ReCaptchaLoader.successfulLoadingConsumers.push(function (instance) { return resolve(instance); });
                ReCaptchaLoader.errorLoadingRunnable.push(function (reason) { return reject(); });
            });
        }
        ReCaptchaLoader.instanceSiteKey = siteKey;
        ReCaptchaLoader.setLoadingState(ELoadingState.LOADING);
        var loader = new ReCaptchaLoader();
        return new Promise(function (resolve, reject) {
            loader.loadScript(siteKey, options.useRecaptchaNet || false).then(function () {
                ReCaptchaLoader.setLoadingState(ELoadingState.LOADED);
                var instance = new ReCaptchaInstance_1.ReCaptchaInstance(siteKey, grecaptcha);
                ReCaptchaLoader.successfulLoadingConsumers.forEach(function (v) { return v(instance); });
                ReCaptchaLoader.successfulLoadingConsumers = [];
                if (options.autoHideBadge || false)
                    instance.hideBadge();
                ReCaptchaLoader.instance = instance;
                resolve(instance);
            }).catch(function (error) {
                ReCaptchaLoader.errorLoadingRunnable.forEach(function (v) { return v(error); });
                ReCaptchaLoader.errorLoadingRunnable = [];
                reject(error);
            });
        });
    };
    ReCaptchaLoader.getInstance = function () {
        return ReCaptchaLoader.instance;
    };
    ReCaptchaLoader.setLoadingState = function (state) {
        ReCaptchaLoader.loadingState = state;
    };
    ReCaptchaLoader.getLoadingState = function () {
        if (ReCaptchaLoader.loadingState === null)
            return ELoadingState.NOT_LOADED;
        else
            return ReCaptchaLoader.loadingState;
    };
    ReCaptchaLoader.prototype.loadScript = function (siteKey, useRecaptchaNet) {
        var _this = this;
        if (useRecaptchaNet === void 0) { useRecaptchaNet = false; }
        var scriptElement = document.createElement('script');
        scriptElement.setAttribute('recaptcha-v3-script', '');
        var scriptBase = 'https://www.google.com/recaptcha/api.js';
        if (useRecaptchaNet)
            scriptBase = 'https://recaptcha.net/recaptcha/api.js';
        scriptElement.src = scriptBase + '?render=' + siteKey;
        return new Promise(function (resolve, reject) {
            scriptElement.addEventListener('load', _this.waitForScriptToLoad(function () {
                resolve(scriptElement);
            }), false);
            scriptElement.onerror = function (error) {
                reject(new Error('Something went wrong while loading ReCaptcha. (' + error.toString() + ')'));
            };
            document.head.appendChild(scriptElement);
        });
    };
    ReCaptchaLoader.prototype.waitForScriptToLoad = function (callback) {
        var _this = this;
        return function () {
            if (window.grecaptcha === undefined)
                setTimeout(function () {
                    _this.waitForScriptToLoad(callback);
                }, 25);
            else
                window.grecaptcha.ready(function () {
                    callback();
                });
        };
    };
    ReCaptchaLoader.loadingState = null;
    ReCaptchaLoader.instance = null;
    ReCaptchaLoader.instanceSiteKey = null;
    ReCaptchaLoader.successfulLoadingConsumers = [];
    ReCaptchaLoader.errorLoadingRunnable = [];
    return ReCaptchaLoader;
}());
var ELoadingState;
(function (ELoadingState) {
    ELoadingState[ELoadingState["NOT_LOADED"] = 0] = "NOT_LOADED";
    ELoadingState[ELoadingState["LOADING"] = 1] = "LOADING";
    ELoadingState[ELoadingState["LOADED"] = 2] = "LOADED";
})(ELoadingState || (ELoadingState = {}));
exports.load = ReCaptchaLoader.load;
exports.getInstance = ReCaptchaLoader.getInstance;



//////////////////
// WEBPACK FOOTER
// ./~/recaptcha-v3/dist/ReCaptchaLoader.js
// module id = tma6
// module chunks = 0